import { calculationLimits, designFastVariables, designRoadClasses } from "store/calculation.config";
import { calculateSuperelevationFromHorizontalData } from "utilities/geometricRoadutilities/calculateSuperelevationFromHorizontalData";

export const calculateSuperelevation = (input) => {
    const errors = {
        TOOLS_SPEEDLIMIT_TOO_LOW: false,
        TOOLS_SPEEDLIMIT_TOO_HIGH: false,
        TOOLS_LANE_WIDTH_TOO_LOW: false,
        TOOLS_LANE_WIDTH_TOO_HIGH: false,
        TOOLS_HORIZONTAL_GEOMETRY_TOO_SHORT: false,
        TOOLS_SUPERELEVATION_DATA_NEED_MANUAL_CORRECTION: false,
    };

    let calculationContext = {
        normalizedInput: {...input},
        wasNormalized: false,
        errorsToSet: [],
        errorsToUnset: [],
        input:
        {
            horizontalGeometry: {value: null, valid: null, severity: null},
            designClass: {value: null, valid: null, severity: null},
            speedlimit: {value: null, valid: null, severity: null},
            laneWidth: {value: null, valid: null, severity: null},
        },
        derived:
        {
            wheelbase: {value: designFastVariables.wheelbase, valid: null, severity: null},
            relativeVerticalSpeed: {value: designFastVariables.relativeVerticalSpeed, valid: null, severity: null},
            speedAddition: {value: null, valid: null, severity: null},
            crossSlope: {value: designFastVariables.crossSlope, valid: null, severity: null},
        },
        output:
        {
            minStationing: {value: null, valid: null, severity: null},
            maxStationing: {value: null, valid: null, severity: null},
            crossSlopeData: {value: null, valid: null, severity: null},
        }
    }

    validateValues(calculationContext, errors);
    calculateDerived(calculationContext, errors);
    calulcateOutput(calculationContext, errors);

    calculationContext.errorsToSet = Object.keys(errors).filter(key => errors[key]);
    calculationContext.errorsToUnset = Object.keys(errors).filter(key => !errors[key]);

    return calculationContext;
}

const validateValues = (ctx, errors) => {
    // #region validating design class
    if(ctx.normalizedInput.designClass.trim() !== '')
    {
        let designClassObject = designRoadClasses[ctx.normalizedInput.designClass];
        if(designClassObject) ctx.input.designClass = {value: designClassObject, valid: true, severity: null};
        else ctx.input.designClass = {value: null, valid: false, severity: 'error'};
    }
    // #endregion

    // #region speedlimit
    if(ctx.normalizedInput.speedlimit.trim() !== '')
    {
        const speedlimit = Number(ctx.normalizedInput.speedlimit.trim());
        if(speedlimit < calculationLimits.minSpeed)
        {
            ctx.input.speedlimit = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_SPEEDLIMIT_TOO_LOW = true;
        }
        else if(speedlimit > calculationLimits.maxSpeed)
        {
            ctx.input.speedlimit = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_SPEEDLIMIT_TOO_HIGH = true;
        }
        else
        {
            ctx.input.speedlimit = {value: speedlimit, valid: true, severity: null};
        }
    }
    // #endregion

    // #region lane width
    if(ctx.normalizedInput.laneWidth.trim() !== '')
    {
        const laneWidth = Number(ctx.normalizedInput.laneWidth.trim());
        if(laneWidth < 1)
        {
            ctx.input.laneWidth = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_LANE_WIDTH_TOO_LOW = true;
        }
        else if(laneWidth > 10)
        {
            ctx.input.laneWidth = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_LANE_WIDTH_TOO_HIGH = true;
        }
        else
        {
            ctx.input.laneWidth = {value: laneWidth, valid: true, severity: null};
        }
    }
    // #endregion

    // #region horizontal geometry
    if(ctx.normalizedInput.horizontalGeometry)
    {
        if(Array.isArray(ctx.normalizedInput.horizontalGeometry) && ctx.normalizedInput.horizontalGeometry.length !== 0)
        {
            ctx.input.horizontalGeometry = {
                value: ctx.normalizedInput.horizontalGeometry,
                valid: true,
                severity: false,
            }
        }
    }
    // #endregion
}

const calculateDerived = (ctx, errors) => {
    if(ctx.input.designClass.valid)
    {
        ctx.derived.speedAddition = {
            value: ctx.input.designClass.value.speedAddition,
            valid: true,
            severity: null
        };
    }
}

const calulcateOutput = (ctx, errors) => {

    if(ctx.input.horizontalGeometry.valid)
    {
        ctx.output.minStationing = {
            value: ctx.input.horizontalGeometry.value[0].startStationing,
            valid: true,
            severity: null
        }

        ctx.output.maxStationing = {
            value: ctx.input.horizontalGeometry.value[ctx.input.horizontalGeometry.value.length-1].endStationing,
            valid: true,
            severity: null
        }
    }

    if(ctx.input.designClass.valid && ctx.input.speedlimit.valid && ctx.input.horizontalGeometry.valid && ctx.input.laneWidth.valid)
    {
        if(ctx.input.horizontalGeometry.value.length <= 3)
        {
            errors.TOOLS_HORIZONTAL_GEOMETRY_TOO_SHORT = true;
            return;
        }

        const [crossSlopeLeftSide, crossSlopeRightSide] = calculateSuperelevationFromHorizontalData({
            speedlimit: ctx.input.speedlimit.value,
            geometry: ctx.input.horizontalGeometry.value,
            designClass: ctx.input.designClass.value,
            normalCrossSlope: ctx.derived.crossSlope.value,
            wheelbase: ctx.derived.wheelbase.value,
            relativeVerticalSpeed: ctx.derived.relativeVerticalSpeed.value,
            speedAddition: ctx.derived.speedAddition.value
        });

        let containsError = crossSlopeLeftSide.some(el => el?.error === true) || crossSlopeRightSide.some(el => el?.error === true);
        if(containsError) errors.TOOLS_SUPERELEVATION_DATA_NEED_MANUAL_CORRECTION = true;

        ctx.output.crossSlopeData = {
            value: {crossSlopeLeftSide, crossSlopeRightSide},
            valid: true,
            severity: null
        }
    }
}